import React from 'react';
import { SideNav } from 'app-components';

const SidebarBottom = () => {

    return (
        <SideNav>
            <SideNav.Header labelId=" " />
            <SideNav.Item>
                <SideNav.ActionLink
                    isSelectedDefault={true}
                    labelId="manage.drugs.search.rxcui"
                    onClickHandler={() => { }}
                />
            </SideNav.Item>

        </SideNav>
    );
};

export default SidebarBottom;
